export default "__VITE_ASSET__ai$EhcgWXFrUmp9a730ngA__"